export const isValidDomain = (portalDomain: string, allowedDomains: string[]): boolean => {
  const portalDomainLower = portalDomain?.toLowerCase() ?? '';
  return (
    Array.isArray(allowedDomains) &&
    allowedDomains.some((domain) => portalDomainLower.includes((domain?.toLowerCase() ?? '')))
  );
};
